import React from 'react';

import { Icon } from '@chakra-ui/react';

export const AgentBuilderIcon = props => (
  <Icon viewBox="0 0 720 720" w="full" h="full" color="inherit" {...props}>
    <g transform="translate(-608 -328)">
      <g>
        <path
          d="M743 575.5 743 463 855.5 463"
          stroke="currentColor"
          strokeWidth="33.75"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="4"
          strokeOpacity="1"
          fill="none"
          fillRule="nonzero"
        />
        <path
          d="M1193 575.5 1193 463 1080.5 463"
          stroke="currentColor"
          strokeWidth="33.75"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="4"
          strokeOpacity="1"
          fill="none"
          fillRule="nonzero"
        />
        <path
          d="M743 800.5 743 913 855.5 913"
          stroke="currentColor"
          strokeWidth="33.75"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="4"
          strokeOpacity="1"
          fill="none"
          fillRule="nonzero"
        />
        <path
          d="M1193 800.5 1193 913 1080.5 913"
          stroke="currentColor"
          strokeWidth="33.75"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="4"
          strokeOpacity="1"
          fill="none"
          fillRule="nonzero"
        />
        <path
          d="M844.25 676.75 821.75 676.75 821.75 699.25 844.25 699.25"
          stroke="currentColor"
          strokeWidth="33.75"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="4"
          strokeOpacity="1"
          fill="none"
          fillRule="nonzero"
        />
        <path
          d="M1091.75 676.75 1114.25 676.75 1114.25 699.25 1091.75 699.25"
          stroke="currentColor"
          strokeWidth="33.75"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="4"
          strokeOpacity="1"
          fill="none"
          fillRule="nonzero"
        />
        <path
          d="M1069.25 575.5C1081.68 575.5 1091.75 585.574 1091.75 598L1091.75 800.5C1091.75 812.926 1081.68 823 1069.25 823L866.75 823C854.324 823 844.25 812.926 844.25 800.5L844.25 598C844.25 585.574 854.324 575.5 866.75 575.5Z"
          stroke="currentColor"
          strokeWidth="33.75"
          strokeLinecap="butt"
          strokeLinejoin="round"
          strokeMiterlimit="4"
          strokeOpacity="1"
          fill="none"
          fillRule="nonzero"
        />
        <path
          d="M939.875 654.25C939.875 669.783 932.32 682.375 923 682.375 913.68 682.375 906.125 669.783 906.125 654.25 906.125 638.717 913.68 626.125 923 626.125 932.32 626.125 939.875 638.717 939.875 654.25Z"
          fill="currentColor"
          fillRule="nonzero"
          fillOpacity="1"
        />
        <path
          d="M1029.88 654.25C1029.88 669.783 1022.32 682.375 1013 682.375 1003.68 682.375 996.125 669.783 996.125 654.25 996.125 638.717 1003.68 626.125 1013 626.125 1022.32 626.125 1029.88 638.717 1029.88 654.25Z"
          fill="currentColor"
          fillRule="nonzero"
          fillOpacity="1"
        />
        <path
          d="M911.75 744.25 1024.25 744.25"
          stroke="currentColor"
          strokeWidth="33.75"
          strokeLinecap="round"
          strokeLinejoin="miter"
          strokeMiterlimit="4"
          strokeOpacity="1"
          fill="none"
          fillRule="nonzero"
        />
        <path
          d="M968 575.5 968 519.25"
          stroke="currentColor"
          strokeWidth="33.75"
          strokeLinecap="round"
          strokeLinejoin="miter"
          strokeMiterlimit="4"
          strokeOpacity="1"
          fill="none"
          fillRule="nonzero"
        />
        <path
          d="M984.875 496.75C984.875 506.07 977.32 513.625 968 513.625 958.68 513.625 951.125 506.07 951.125 496.75 951.125 487.43 958.68 479.875 968 479.875 977.32 479.875 984.875 487.43 984.875 496.75Z"
          fill="currentColor"
          fillRule="nonzero"
          fillOpacity="1"
        />
      </g>
    </g>
  </Icon>
);
